import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg viewBox="0 0 30 32" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...this.props}><path d="M27.866 15.298l1.415-1.414-7.026-7.026-7.025 7.026 1.414 1.414 5.61-5.612" /><path d="M21.255 25.266l-5.328 5.328 1.414 1.414 5.915-5.914V8.272h-2M1.388 16.655L-.026 18.07 7 25.093l7.026-7.025-1.414-1.415L7 22.265" /><path d="M13.01 1.677L11.594.263 6 5.858V23.68h2V6.686" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/panel-switch.inline.svg